import { render, staticRenderFns } from "./Elegant.vue?vue&type=template&id=c0d87df6&scoped=true&"
import script from "./Elegant.vue?vue&type=script&lang=js&"
export * from "./Elegant.vue?vue&type=script&lang=js&"
import style0 from "./Elegant.vue?vue&type=style&index=0&id=c0d87df6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d87df6",
  null
  
)

export default component.exports